import React, { Component } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from "@material-ui/core/styles";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';

const styles = theme => ({
  labelMargin: {
    "margin-bottom": 0,
  }
});

class PriceSortingSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      logged: this.props.logged,
      price_sort: this.props.price_sort,
      setPriceSorting: this.props.setPriceSorting,
      current: this.props.current
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {

    const { current, setPriceSorting } = this.state;

    this.setState({
      [event.target.name]: event.target.value
    });
    this.props.setPriceSorting(event.target.value, current);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.current != this.props.current) {
      this.setState({ current: this.props.current })
    }
  }

  render() {
    const { lang, logged, price_sort, dropDownValue } = this.state;
    const { t } = this.props;
    const { classes } = this.props;

    return (
      <>
        <FormControl
          className="select-box"
        >
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={price_sort}
            onChange={(e) => this.handleChange(e)}
            label="Value"
            name="price_sort"
          >

            <MenuItem value="no_filter" key={"key_no_sort"}><Trans>No price sorting</Trans></MenuItem>
            <MenuItem value="asc" key={"key_asc"}><Trans>Sort by price (Ascending)</Trans></MenuItem>
            <MenuItem value="desc" key={"key_desc"}><Trans>Sort by price (Descending)</Trans></MenuItem>
          </Select>
        </FormControl>

      </>
    );
  }
}

export default withStyles(styles)(withTranslation()(PriceSortingSelector));